import React, { useState, useRef, useEffect, useMemo } from "react";
import { useLocation, Link, Routes, Route, useParams, useNavigate, useSearchParams } from "react-router-dom";
import '../FilesView/FilesView.css';
import FilesViewContent from "../FilesView/FilesViewContent";
import FilesViewModal from "../FilesView/FilesViewModal";
import { ToastContainer, toast } from "react-toastify";
import Swal from "sweetalert2";
// import "react-toastify/dist/ReactToastify.css";
import withReactContent from "sweetalert2-react-content";
import { useFacultyFilesViewStore, useAppStore } from "../../stores";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import UppyModal from "../UppyModal/UppyModal";
import FacultyUploadModal from "./FacultyUploadModal";
import { handleXhrError } from "../../utils";
//toast
const toastOptions = {
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

//sweetalert
const MySwal = withReactContent(Swal);

const FacultyFilesView = (props) => {
  const [open, setOpen] = useState(false);
  const modalRef = useRef({});
  // const handleFile = (file) => {
  //   console.log(modalRef);
  //   modalRef.current = file
  //   setOpen(true);
  // }
  const { fId, subId } = useParams();
  const [search] = useSearchParams();
  const year = search.get("year");
  const sem = search.get("sem");
  const branch = search.get("branch");
  const location = useLocation();
  const navigate = useNavigate();
  const locationState = location.state || {};
  const addAll = useFacultyFilesViewStore((state) => state.addAll);
  const files = useFacultyFilesViewStore((state) => state.files);
  const showLoading = useAppStore(state => state.showLoading);
  const hideLoading = useAppStore(state => state.hideLoading);
  const filesLoading = useFacultyFilesViewStore((state) => state.loading);
  const subject = useFacultyFilesViewStore((state) => state.subject);
  console.log(subject);
  const showOptions = {
    onDelete: async (fId) => {
      console.log(fId);
      const r = await fetch("/api/faculty/files/" + fId, {
        method: "DELETE"
      })
      if (r.status == 200) {
        // alert("Deleted successfully");

        toast.success("Deleted successfully", toastOptions);
        setTimeout(() => window.location.reload(), 1000);
      }
      else {
        // alert("Something went wrong");
        toast.error("Something went wrong", toastOptions);
      }
    }
  };
  useEffect(() => {
    if (fId && !filesLoading) {
      const file = files.filter(f => f._id == fId)[0];
      if (file) {
        modalRef.current = file;
        console.log(file);
        setOpen(true);
      }
      else {
        navigate(`/faculty/files/${subId}?year=${year}&sem=${sem}&branch=${branch}`, { state: { error: "No such file found" } });
      }
    }
    else {
      // navigate(`/files/${subId}/${secId}/${batch}/${facId}`);
    }
  }, [fId, filesLoading])
  useEffect(() => {
    if (filesLoading) {
      showLoading();
    }
    else {
      hideLoading();
    }
  }, [filesLoading])
  useEffect(() => {
    window.$.ajax({
      type: "get",
      url: `/api/faculty/files/${subId}?year=${year}&sem=${sem}&branch=${branch}`,
      xhrFields: {
        withCredentials: true,
      },
      dataType: "json",
      success: (response, textStatus, request) => {
        addAll(response);
      },
      statusCode: {

        404: function () {

          toast.error("page not found", toastOptions);
        },
        400: function (res) {
          if (!res.responseJSON) {
            toast.error("Something went wrong...", toastOptions);
            return;
          }

          toast.error(res.responseJSON.message, toastOptions);
          return;
        },
      },
      headers: {
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "",
      },
      error: function (res, textStatus, err) {
        handleXhrError(res, textStatus, err, () => {
          // e.target.disabled = false;
        })
      },
    });
  }, [])
  const handleOnClose = () => {
    setOpen(false);
    navigate(`/faculty/files/${subId}?year=${year}&sem=${sem}&branch=${branch}`);
  }
  if (filesLoading) {
    return <></>
  }

  return (
    <>
      {/* <ToastContainer /> */}
      <div className="p-2">
        <div className="d-flex ps-5 pe-5" style={{ justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <h4 className="p-0 m-0 me-2">{subject ? subject.name : ""}</h4>
            <h4 className="p-0 m-0" style={{ textAlign: "right", width: "100%" }}>{subject ? subject.year : ""}{"yr - "}{subject ? subject.sem : ""}sem</h4>
          </div>
          <FacultyUploadModal subject={subject} sem={sem} />
        </div>

        <h6>{locationState.error}</h6>
        <div className="row p-3">
          {
            files.map(file => <FilesViewContent  {...file} year={year} sem={sem} showOptions={showOptions} branch={branch} />)
          }
        </div>
      </div>
      <FilesViewModal ref={modalRef} open={open} onClose={handleOnClose} />
    </>
  );
};

export default FacultyFilesView;
